import {useVoluntaryTermLifeCoveragePopulator} from '../populator/useVoluntaryTermLifeCoveragePopulator';
import {useDispatch} from 'react-redux';

export const useVoluntaryTermLifeCoverageDispatcher = () => {
    const populateVoluntaryTermLifeCoverage = useVoluntaryTermLifeCoveragePopulator();
    const dispatch = useDispatch();

    const dispatchCoverage = (selectedRate, selectedBenefitKey) => {
        const data = populateVoluntaryTermLifeCoverage(selectedRate, selectedBenefitKey);
        dispatch({
            type: 'UPDATE_MEMBER_ELECTION',
            data: data
        });
    };

    return (selectedRate, selectedBenefitKey) => dispatchCoverage(selectedRate, selectedBenefitKey);
};